import React, { useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import TechSolutions from '../components/TechSolutions';
import UserProfiles from '../components/UserProfiles';
import About from '../components/About';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Services />
      <TechSolutions />
      <UserProfiles />
      <About />
      <ContactForm />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Home;
